import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eTienDoNhapDiemLopHanhChinhActionIds, ITienDoNhapDiemLopHanhChinhActionTypes } from "../../action-types/tong-hop/ITienDoNhapDiemLopHanhChinhActions";
import { tienDoNhapDiemApi } from "../../../api/tong-hop/tienDoNhapDiemApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { ITienDoNhapDiemLopHanhChinhRequest } from "../../../model/request/tong-hop/ITienDoNhapDiemLopHanhChinhRequest";


export function* tienDoNhapDiemLopHanhChinhSaga(): any {
    yield takeLatest(eTienDoNhapDiemLopHanhChinhActionIds.THANH_PHAN_LOAD_START, loadLopHanhChinhWorker);
    yield takeLatest(eTienDoNhapDiemLopHanhChinhActionIds.THI_LOAD_START, loadThiWorker);
}


function* loadLopHanhChinhWorker(action: ITienDoNhapDiemLopHanhChinhActionTypes) {
    const request = action.payload as ITienDoNhapDiemLopHanhChinhRequest;
    const response: IBaseResponse = yield call(tienDoNhapDiemApi.SelectLopHanhChinhThanhPhan, request);
    if (response.is_success) {
        yield put(rootActions.tongHop.tienDoNhapDiemLopHanhChinh.THANH_PHAN_LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.tongHop.tienDoNhapDiemLopHanhChinh.THANH_PHAN_LOAD_ERROR(response.message ?? "Có lỗi"));
    }
}

function* loadThiWorker(action: ITienDoNhapDiemLopHanhChinhActionTypes) {
    const request = action.payload as ITienDoNhapDiemLopHanhChinhRequest;
    const response: IBaseResponse = yield call(tienDoNhapDiemApi.SelectLopHanhChinhThi, request);
    if (response.is_success) {
        yield put(rootActions.tongHop.tienDoNhapDiemLopHanhChinh.THI_LOAD_SUCCESS(toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.tongHop.tienDoNhapDiemLopHanhChinh.THI_LOAD_ERROR(response.message ?? "Có lỗi"));
    }
}